import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  saveInvoice(form) {
    return this.http.post(this.rootUrl + '/api/Invoice/SaveInvoice', form);
  }
  invoiceListSearch(keywrd) {
    const key = {
      keyword: keywrd
    }

    return this.http.post(this.rootUrl + '/api/Invoice/invoiceListSearch', key);
  }
  GetPurchaseOrderList() {
    return this.http.get(this.rootUrl + '/api/Invoice/GetPurchaseOrderList');
  }
  uploadVendorInvoice(FormData) {
    return this.http.post(this.rootUrl + '/api/Invoice/UploadVendorInvoice', FormData);
  }
  saveVendorInvoiceLines(lines) {
    return this.http.post(this.rootUrl + '/api/Invoice/SaveVendorInvoiceLines', lines);
  }
  GetInvoiceDocs() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Invoice/GetInvoiceDocs');
  }
  InvoiceVendorSearch(keywrd) {
    const key = {
      keyword: keywrd
    }

    return this.http.post(this.rootUrl + '/api/Invoice/InvoiceVendorSearch', key);
  }

  getInvoiceLines(purchno) {
    const purchase = {
      purchaseOrderNo: purchno
    }

    return this.http.post(this.rootUrl + '/api/Invoice/GetInvoiceLines', purchase);
  }

  getAllInvoiceList() {
    return this.http.get(this.rootUrl + '/api/Invoice/GetAllInvoiceList');
  }

  syncNavPaidInvoice() {
    return this.http.get(this.rootUrl + '/api/Invoice/SyncNavPaidInvoiceList');
  }

  getNavPaidInvoice() {
    return this.http.get(this.rootUrl + '/api/Invoice/GetNavPaidInvoiceList');
  }

  getVendorPaidInvoiceList() {
    return this.http.get(this.rootUrl + '/api/Invoice/GetVendorPaidInvoiceList');
  }

  getSelectedInvoiceLines(invoiceid) {
    const invoice = {
      vendorInvoiceId: invoiceid
    }

    return this.http.post(this.rootUrl + '/api/Invoice/GetSelectedInvoiceLines', invoice);
  }

  GetInvoiceById(id) {
    const order = {
      invoiceId : id
    }
    return this.http.post(this.rootUrl + '/api/Invoice/GetInvoiceById', order);
  }

  submitInvoiceApproval(form) {
    return this.http.post(this.rootUrl + '/api/Invoice/SubmitInvoiceApproval', form);
  }

  searchInvoice(keywrd){
    const key = {
      keyword : keywrd
    }
    return this.http.post(this.rootUrl + '/api/Invoice/SearchInvoice', key);
  }

}
